import type { ILocatedElement } from 'clickim/src/background/codeSnippets/getLocatedElement';

interface EventMessage {
    fromLocatedElement: ILocatedElement;
    toLocatedElement: ILocatedElement;
}
declare function getLocatedElement(locatedElement: ILocatedElement | string): Element | null;

export const html5dndAction = function (eventData: EventMessage) {
    const data: { [key: string]: any } = {};
    function convertType(type: string) {
        if (!type?.toLowerCase) {
            return type;
        }
        type = type.toLowerCase();
        if (type === 'text') {
            return 'text/plain';
        }
        if (type === 'url') {
            return 'text/uri-list';
        }
        return type;
    }
    const dataTransfer = {
        data: {
        },
        setData(type: string, val: any) {
            data[convertType(type)] = val;
        },
        getData(type: string) {
            return data[convertType(type)];
        },
    };
    const fromElement = getLocatedElement(eventData.fromLocatedElement);
    const toElement = getLocatedElement(eventData.toLocatedElement);

    if (!fromElement) {
        throw new Error('from element not found');
    }

    if (!toElement) {
        throw new Error('to element not found');
    }

    const dispatchEvent = function (element: Element, type: string) {
        const event = document.createEvent('CustomEvent');
        event.initCustomEvent(type, true, true, null);
        Object.assign(event, { dataTransfer });
        if (element.dispatchEvent) {
            element.dispatchEvent(event);
        } else if ((element as any).fireEvent) {
            (element as any).fireEvent(`on${type}`, event);
        }
    };
    dispatchEvent(fromElement, 'dragstart');
    dispatchEvent(toElement, 'drop');
    dispatchEvent(fromElement, 'dragend');
};
